import styled from 'styled-components';

const StyledSignAndLogin = styled.div`
  display: flex;
  padding: 0 7px;
  width: 100%;
  height: 50px;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  background-color: #17936F;
  border-radius: 0 0 5px 5px;
  img {
    height: 20px;
  }
  a {
    color: #fff;
    text-decoration: underline;
  }
  @media screen and (max-width: 768px) {
    //flex-wrap: wrap;
    padding: 0 35px;
    img {
      margin-right: 10px;
    }
  }
`;

export default StyledSignAndLogin;
